import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TooltipDirective } from '../directives/tooltip.directive';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'chips-selects',
  standalone: true,
  imports: [TooltipDirective, ReactiveFormsModule],
  templateUrl: './chips-selects.component.html',
  styleUrl: './chips-selects.component.scss',
})
export class ChipsSelectsComponent {
  editarLabel: boolean = false;
  oldValue: string = '';
  @Input() color: TypeColors = 'default';
  @Input() label: string = '';
  @Input() _clicked: boolean = false;
  @Input() edit: boolean = false;
  @Input() control!: FormControl;
  @Input() mode: 'outline' | 'default' = 'default';
  @Output() clicked = new EventEmitter<any>();
  @Output() editado = new EventEmitter<any>();

  // protected _clicked = false;

  colors: Colors = {
    primary: '#00A73B',
    warning: '',
    success: '',
    error: '',
    info: '',
    default: '',
  };

  deletarChip() {}

  editar() {
    this.editarLabel = !this.editarLabel;
    this.oldValue = this.control.value
  }

  clickAction(label: string) {
    this.clicked.emit(label);
  }

  emitirControl() {
    this.editarLabel = false;
    const valor: any = {control: this.control.value, label: this.label}
    this.editado.emit(valor); // valor atualizado aqui
  }

  pegarValor() {
    this.control.setValue(this.oldValue);
    this.editarLabel = !this.editarLabel;
  }
}

type TypeColors =
  | 'primary'
  | 'warning'
  | 'success'
  | 'error'
  | 'info'
  | 'default';
type Colors = {
  [key in TypeColors]: string;
};
